import Network from "@/types/Network";

export default {
  [Network.homestead]: 0,
  [Network.arbitrum]: 1,
  [Network.polygon]: 2
};
